import { render, staticRenderFns } from "./apply_change.vue?vue&type=template&id=6d0b61b7&scoped=true&"
import script from "./apply_change.vue?vue&type=script&lang=js&"
export * from "./apply_change.vue?vue&type=script&lang=js&"
import style0 from "./apply_change.vue?vue&type=style&index=0&id=6d0b61b7&lang=scss&scoped=true&"
import style1 from "./apply_change.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b61b7",
  null
  
)

export default component.exports